//src\app\app.component.ts
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { WebsocketService } from "./shared/websocket.service";

@Component({
  selector: "iw-websocket",
  templateUrl: "./websocket.component.html",
  styleUrls: ["./websocket.component.scss"],
  providers: [WebsocketService]
})

export class WebSocketComponent implements OnInit, OnDestroy{
  title:any = 'socketrv';
  content:any = '1100';
  received:any = [];
  sent:any = [];
  private searchEventSubscription: Subscription;
  
  constructor(private WebsocketService: WebsocketService) {
    
  }

  ngOnInit(): void {
    this.searchEventSubscription = this.WebsocketService.messages.subscribe(msg => {
      var file = new Blob([msg], {type: 'application/pdf'});
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
      // let byteCharacters: any = atob(msg.Bytes);
      // let byteNumbers = new Array(byteCharacters.length);
      // for (var i = 0; i < byteCharacters.length; i++) {
      // byteNumbers[i] = byteCharacters.charCodeAt(i);
      // }
      // var byteArray = new Uint8Array(byteNumbers);
      // var blob = new Blob([byteArray], {type: "application/pdf"});
      // var fileURL = URL.createObjectURL(blob);
      // // this.received.push(fileURL);
      // console.log("Response from websocket: " + msg);
    });
  }
  ngOnDestroy(): void {
    this.searchEventSubscription.unsubscribe();
  }

  sendMsg() {
    let message = {
      source: '',
      content: '1100'
    };
    message.source = 'localhost';
    message.content = this.content;

    this.sent.push(message);
    this.WebsocketService.messages.next("1100");
  }
}


// WEBPACK FOOTER //
// ./src/app/examples/websocket/websocket.component.ts